"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var fields_path_service_1 = require("../../service/fields-path/fields-path-service");
var field_picker_direction_1 = require("./model/field-picker-direction");
var FieldPickerComponent = /** @class */ (function () {
    function FieldPickerComponent(fieldsPathService) {
        this.fieldsPathService = fieldsPathService;
        this.fieldPickerChange = new core_1.EventEmitter();
        this.includeStandardFields = true;
        this._openSubscriptions = [];
        this.firstFieldDisabled = false;
        this.fieldViewsViewModel = [];
    }
    FieldPickerComponent.prototype.ngOnDestroy = function () {
        this._openSubscriptions.forEach(function (subscription) { return subscription.unsubscribe(); });
    };
    FieldPickerComponent.prototype.ngOnChanges = function () {
        if (this.records && this.records.length) {
            this.constructInitialData();
            // disable first field, if there is only one option, or no option(invalid case)
            if (this.fieldViewsViewModel[0].options && this.fieldViewsViewModel[0].options.length) {
                this.firstFieldDisabled = this.fieldViewsViewModel[0].options.length === 1;
            }
            else {
                this.firstFieldDisabled = true;
            }
        }
    };
    FieldPickerComponent.prototype.changeDirection = function (index) {
        var reversedDirection = field_picker_direction_1.FieldPickerDirection.reverse(this.fieldViewsViewModel[index].direction);
        this.fieldViewsViewModel[index].direction = reversedDirection;
        this.fieldViewsViewModel.splice(index + 1);
        this.addBinding(reversedDirection);
        this.emitChanges();
    };
    FieldPickerComponent.prototype.addBinding = function (direction) {
        var _this = this;
        var lastIndex = this.fieldViewsViewModel.length - 1;
        this.getOptions(direction, this.fieldViewsViewModel[lastIndex].selectedField.targetCategory).subscribe(function (fields) {
            _this.addField(lastIndex, fields);
        });
    };
    FieldPickerComponent.prototype.addField = function (index, options) {
        this.fieldViewsViewModel.push({
            selectedField: undefined,
            direction: field_picker_direction_1.FieldPickerDirection.OUTGOING,
            options: options
        });
    };
    FieldPickerComponent.prototype.selectCurrentField = function (index) {
        this.fieldViewsViewModel.splice(index + 1);
        this.emitChanges();
    };
    FieldPickerComponent.prototype.emitChanges = function () {
        var output = [];
        for (var _i = 0, _a = this.fieldViewsViewModel; _i < _a.length; _i++) {
            var record = _a[_i];
            output.push({
                selectedField: record.selectedField,
                direction: record.direction
            });
        }
        this.fieldPickerChange.emit(output);
    };
    FieldPickerComponent.prototype.retrieveOptions = function (record, index) {
        if (record.optionsRetrievalIsNeeded) {
            var lastField = this.fieldViewsViewModel[index - 1];
            this.getOptions(lastField.direction, lastField.selectedField.targetCategory).subscribe(function (fields) {
                record.options = fields;
                if (record.selectedField) {
                    record.selectedField = fields.find(function (field) { return field.value === record.selectedField.value; });
                }
                record.optionsRetrievalIsNeeded = false;
            });
        }
    };
    FieldPickerComponent.prototype.constructInitialData = function () {
        var _this = this;
        this.fieldViewsViewModel = [];
        this.records.forEach(function (record, i) {
            _this.fieldViewsViewModel.push({
                selectedField: record.selectedField,
                direction: record.direction,
                options: _this.constructInitialOptions(i),
                optionsRetrievalIsNeeded: i > 0
            });
        });
        var lastIndex = this.fieldViewsViewModel.length - 1;
        if (this.fieldViewsViewModel.length === 1) {
            this.addBinding(this.fieldViewsViewModel[0].direction);
        }
    };
    /**
     *
     * The component should get an array of FieldViews, but the client is not required to construct options for all fields.
     * The client can give options only for the first field.
     * This method constructs the initial options, so the fields will be selected in the comboboxes,
     * all other options will be retrieved when the user will click on the combobox.
     * For this purpose, this method puts the selected field in the options for all fields except the first one.
     * For the first one given options will be preserved if provided.
     *
     * @param i index of the field
     * @private
     */
    FieldPickerComponent.prototype.constructInitialOptions = function (i) {
        if (i === 0 && this.records[i].options.length > 1) {
            return this.records[i].options;
        }
        else if (this.records[i].selectedField) {
            return [this.records[i].selectedField];
        }
        return [];
    };
    /**
     * Get options for a combobox
     * Options are the outgoing or incoming fields from the given category
     *
     * @param direction
     * @param category
     * @private
     */
    FieldPickerComponent.prototype.getOptions = function (direction, category) {
        if (direction === field_picker_direction_1.FieldPickerDirection.OUTGOING) {
            if (this.includeStandardFields) {
                return this.fieldsPathService.getAllOutgoingFields(category);
            }
            else {
                return this.fieldsPathService.getOutgoingFields(category);
            }
        }
        else if (direction === field_picker_direction_1.FieldPickerDirection.INCOMING) {
            return this.fieldsPathService.getAllIncomingFields(category);
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], FieldPickerComponent.prototype, "records", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], FieldPickerComponent.prototype, "fieldPickerChange", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], FieldPickerComponent.prototype, "includeStandardFields", void 0);
    FieldPickerComponent = __decorate([
        core_1.Component({
            
            selector: 'sis-field-picker',
            template: require('./field-picker.component.html'),
            styles: [require('./field-picker.component.css')]
        }),
        __metadata("design:paramtypes", [fields_path_service_1.FieldsPathService])
    ], FieldPickerComponent);
    return FieldPickerComponent;
}());
exports.FieldPickerComponent = FieldPickerComponent;
//# sourceMappingURL=field-picker.component.js.map